"use strict";import{Search as e}from"./src/Search.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-search",e);
//# sourceMappingURL=sp-search.js.map
